import React from "react";
import { useParams } from "react-router-dom";

import {
  Box,
  Heading,
  Text,
  List,
  ListItem,
  Divider,
  SimpleGrid,
  Flex

} from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import bg from "../../assets/images/Logobg.jpeg";
import CaseStudiesWork from "../CaseStudies/CaseStudiesWork.js";
import { Waypoint } from "react-waypoint";
const Section = ({ title, children }) => (
  <Box mb={6}>
    <Heading size="lg" mb={2}>
      {title}
    </Heading>
    {children}
  </Box>
);

const CaseStudyDetail = () => {
  const { id } = useParams();
  const study = CaseStudiesWork.find((s) => s.id === id);

  if (!study) return <Text>Case study not found</Text>;

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          {study.title} | AKIA Flow Assurance Case Study
        </title>

        <meta
          name="description"
          content={study.overview}
        />

        <meta
          name="keywords"
          content={`${study.title}, Flow Assurance Study, Process Engineering, OLGA Simulation, Pipeline Analysis`}
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content={`${study.title} | AKIA Flow Assurance`}
        />

        <meta
          property="og:description"
          content={study.overview}
        />

        <link
          rel="canonical"
          href={`https://www.akiaflowassurance.com/case-study/${study.id}`}
        />
      </Helmet>

      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${bg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}

        w="100vw"

        minH="100vh"
        color={"whiteAlpha.900"}


        align="center"        // vertical center ✅
        justify={{base:"left" ,"3sm":"left" }}     // horizontal center ✅

        pl={{ base: "0.5rem", md: "55rem", lg: "65rem" }}


       
      >
        <Box
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"4rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain5").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain5">
                <Heading
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.0rem" }}
                  textTransform={"uppercase"}
                  fontFamily={"Roboto Condensed, Lato, Sans-serif"}
                  flexShrink={"0"}
                  w={"fit-content"}
                >
                  Case Studies
                </Heading>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      <Flex
        overflow={"hidden"}

        pos={"relative"}
        overflowX={"hidden"}
        w={{base:"100%", md:"75%"}}
        mt={"10rem"}
        mb={"5rem"}

      >

        <Box
          bg="blackAlpha.900"
           borderWidth="1px"
              borderRadius="2xl"
               borderWidth="3px"
              borderStyle="solid"
             
              borderColor="rgb(236, 24, 24)"
          
              color={"whiteAlpha.900"}
          
          
          w="100%"
          mx={{base:"2rem", md:"4rem"}}
          p={{ base: 8, md: 14 }}
         
          boxShadow="0 0 20px rgba(0,0,0,0.4)"
         
        >

       
          <Heading fontSize={"2.5rem"} mb={4}>{study.title}</Heading>

          <Text fontSize={"1.8rem"} mb={6}>
            {study.summary}
          </Text>

          <Divider borderColor={"red"} borderWidth="1.5px" mb={6} />

          <Section title="Overview">
            <Text fontSize={"1.8rem"}>{study.overview}</Text>
          </Section>

          <Section title="Objective">
            <Text fontSize={"1.8rem"} > {study.objective}</Text>
          </Section>

          <Section title="Scope">
            <List fontSize={"1.8rem"}  spacing={2} styleType="disc" stylePosition="outside" mt={{base:4,md:0}} ml={{base:6, md:8}}>
              {study.scope.map((item, i) => (
                <ListItem key={i}>{item}</ListItem>
              ))}
            </List>
          </Section>

          <Section title="Key Findings">
            <List fontSize={"1.8rem"}   spacing={2} styleType="disc" stylePosition="outside" mt={{base:4,md:0}} ml={{base:6, md:8}}>
              {study.findings.map((item, i) => (
                <ListItem key={i}>{item}</ListItem>
              ))}
            </List>
          </Section>

          <Section title="Recommendations">
            <List fontSize={"1.8rem"}   spacing={2} styleType="disc" stylePosition="outside" mt={{base:4,md:0}} ml={{base:6, md:8}}>
              {study.recommendations.map((item, i) => (
                <ListItem key={i}>{item}</ListItem>
              ))}
            </List>
          </Section>

          <Section title="Engineering Value">
            <Text fontSize={"1.8rem"} fontWeight="medium">{study.value}</Text>
          </Section>
       
        </Box>

      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
            id="phone"
            style={{ flex: "0 0 22%" }}
            href="https://wa.me/+971501232838"
          >

            <Heading fontSize={"4rem"}>
              <i
                className="fa-brands fa-square-whatsapp"
                style={{ color: "green" }}
              />
            </Heading>



          </a>
            <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>



    </Flex>

  );
};

export default CaseStudyDetail;